import isUnknownObject from './isUnknownObject';
import NodeTypes from './NodeTypes';
export default function isElement(node) {
  return isUnknownObject(node) && node.nodeType === NodeTypes.ELEMENT_NODE;
}
//# sourceMappingURL=isElement.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/postmessage/~/@flowio/browser-helpers/lib/esm/isElement.js
// module id = 153
// module chunks = 0 1